import { Controller } from 'libraries/front-end-core/core/Router'
import Main from 'pages/static/Main'
import NotFound from 'components/NotFound'
import content from 'static'
import getUrl from 'libraries/front-end-core/core/url'
import { URL_TERMS_OF_USE, URL_PRIVACY_POLICY } from 'constants/links'
import { STATIC } from 'constants/controllers'

export default new Controller({
  name: STATIC,
  route: '(:flavour/)page/:page(/*anchor)',
  controller (Router, { scrollMain, url, params: { flavour, page, anchor = null } }, render) {
    const bottleLink = flavour => getUrl('static', { flavour, page })
    const pageId = getUrl('static', { page })
    const _anchor = (anchor) => getUrl('static', { flavour, page, anchor })
    const _getUrl = (name, params = {}) => getUrl(name, Object.assign({ flavour }, params))
    const hasPage = Object.prototype.hasOwnProperty.call(content, page)

    render(
      { Main: hasPage ? Main : NotFound },
      { content: hasPage ? content[page]({ url: _getUrl, flavour, page, anchor: _anchor, URL_TERMS_OF_USE, URL_PRIVACY_POLICY }) : null },
      {
        flavour,
        bottleLink,
        pageId,
        searchType: 'qa',
        className: `static ${page}`
      }
    )

    return pageId
  }
})
